export default __webpack_public_path__ + "static/media/EM0120.34I-19690_-25382_0.d4e789e0.jpg";